export default [
  {
    title: 'Dashboard',
    group: 'dashboard',
    icon: 'dashboard',
    i18n: 'Dashboard',
    items: [
      {
        name: 'Operational',
        title: 'Operational',
        prependIcon: 'dashboard',
        i18n: 'Operational',
      },
      {
        name: 'Analytical',
        title: 'Analytical',
        prependIcon: 'dashboard',
        i18n: 'Analytical',
      },
    ],
  },
  { header: 'App', i18n: 'App' },
  { icon: 'contacts', title: 'Contacts', name: 'Contacts', i18n: 'Contacts' },
  {
    icon: 'image', // 메뉴 아이콘 (mdi-image 같은 Vuetify 아이콘도 사용 가능)
    title: 'Image Labeling', // 메뉴 제목
    name: 'ImageLabeling', // 라우트와 매칭되는 이름
    i18n: 'ImageLabeling', // 다국어 지원
  },
  { icon: 'chat', title: 'Chat', name: 'Chat', i18n: 'Chat' },
  { header: 'Style & User Interface', i18n: 'StyleUserInterface' },
  { icon: 'color_lens', title: 'Color', name: 'ColorsUI', i18n: 'Color' },
  { icon: 'collections', title: 'Icons', name: 'IconsView', i18n: 'Icons' },
  { icon: 'help', title: 'Helpers', name: 'HelpersView', i18n: 'Helpers' },
  {
    icon: 'rounded_corner',
    title: 'Border Radius',
    name: 'BorderRadius',
    i18n: 'BorderRadius',
    badge: 'new',
  },
  {
    icon: 'text_fields',
    title: 'Text & Typography',
    name: 'TextTypographyView',
    i18n: 'TextTypography',
    badge: 'new',
  },
  { icon: 'slideshow', title: 'Motion', name: 'Transitions', i18n: 'Motion' },
  {
    title: 'Programmatic Scrolling',
    name: 'Scroll',
    i18n: 'ProgrammaticScrolling',
  },
  { icon: 'input', title: 'Forms', name: 'Forms', i18n: 'Forms' },
  { header: 'Pages', i18n: 'Pages' },
  { icon: 'people', title: 'Profile', name: 'ProfileView', i18n: 'Profile' },
  {
    icon: 'timer',
    title: 'Coming Soon',
    name: 'ComingSoon',
    i18n: 'ComingSoon',
  },
  {
    icon: 'build',
    title: 'Maintenance',
    name: 'MaintenancePage',
    i18n: 'Maintenance',
  },
  {
    title: 'Authentication',
    group: 'pages/authentication',
    icon: 'lock',
    i18n: 'Authentication',
    items: [
      { name: 'LoginPage', title: 'Login', i18n: 'Login' },
      { name: 'SignupPage', title: 'Sign Up', i18n: 'SignUp' },
      {
        name: 'ForgotPasswordPage',
        title: 'Forgot Password',
        i18n: 'ForgotPassword',
      },
      { name: 'LockScreenPage', title: 'Lock Screen', i18n: 'LockScreen' },
    ],
  },
  {
    title: 'Error',
    group: 'pages/error',
    icon: 'error',
    i18n: 'Error',
    items: [
      { name: 'Error404', title: '404', i18n: '404' },
      { name: 'Error500', title: '500', i18n: '500' },
    ],
  },
  { header: 'UI Components', i18n: 'UiComponents' },
  {
    title: 'Charts',
    group: 'charts',
    icon: 'insert_chart',
    i18n: 'Charts',
    items: [
      {
        name: 'SparkLine',
        title: 'Spark Line',
        icon: 'offline_bolt',
        i18n: 'SparkLine',
      },
      {
        name: 'ChartJs',
        title: 'ChartJS',
        icon: 'insert_chart_outlined',
        i18n: 'ChartJs',
      },
    ],
  },
  {
    title: 'Widgets',
    group: 'widgets',
    icon: 'widgets',
    i18n: 'Widgets',
    items: [
      { name: 'CardWidgets', title: 'Cards', i18n: 'Cards' },
      { name: 'ListWidgets', title: 'Lists', i18n: 'Lists' },
      { name: 'StatisticWidgets', title: 'Statistic', i18n: 'Statistic' },
      { name: 'ChartWidgets', title: 'Chart', i18n: 'Chart' },
      {
        name: 'DocumentWidgets',
        title: 'Document Cards',
        i18n: 'DocumentCards',
      },
    ],
  },
  {
    title: 'Vuetify',
    group: 'components',
    icon: 'dashboard',
    i18n: 'Vuetify',
    items: [
      { name: 'ApiExplorerView', title: 'Api Explorer', i18n: 'ApiExplorer' },
      { name: 'AlertsView', title: 'Alerts', i18n: 'Alerts' },
      { name: 'AvatarsView', title: 'Avatars', i18n: 'Avatars' },
      { name: 'BadgeView', title: 'Badges', i18n: 'Badges' },
      { name: 'BannersView', title: 'Banners', i18n: 'Banners' },
      {
        title: 'Bars',
        group: 'bars',
        namespace: 'components',
        i18n: 'Bars',
        items: [
          { name: 'AppBarsView', title: 'App Bars', i18n: 'AppBars' },
          { name: 'ToolbarView', title: 'Toolbar', i18n: 'Toolbar' },
          { name: 'SystemBarsView', title: 'System bars', i18n: 'SystemBars' },
        ],
      },
      {
        name: 'BottomNavigationView',
        title: 'Bottom Navigation',
        i18n: 'BottomNavigation',
      },
      {
        name: 'BottomSheetsView',
        title: 'Bottom Sheets',
        i18n: 'BottomSheets',
      },
      { name: 'Breadcrumbs', title: 'Breadcrumbs', i18n: 'Breadcrumbs' },
      {
        title: 'Buttons',
        group: 'buttons',
        namespace: 'components',
        i18n: 'Buttons',
        items: [
          { name: 'Buttons', title: 'Buttons', exact: true, i18n: 'Buttons' },
          {
            name: 'FloatingActionButtons',
            title: 'Floating Action',
            i18n: 'FloatingAction',
          },
          {
            name: 'ButtonGroups',
            title: 'Button Groups',
            i18n: 'ButtonGroups',
          },
        ],
      },
      { name: 'Calendars', title: 'Calendars', i18n: 'Calendars' },
      { name: 'Cards', title: 'Cards', i18n: 'Cards' },
      { name: 'Carousels', title: 'Carousels', i18n: 'Carousels' },
      {
        title: 'Chips',
        group: 'chips',
        namespace: 'components',
        i18n: 'Chips',
        items: [
          { name: 'Chips', title: 'Chips', exact: true, i18n: 'Chips' },
          { name: 'ChipGroups', title: 'Chip Groups', i18n: 'ChipGroups' },
        ],
      },
      { name: 'Dialogs', title: 'Dialogs', i18n: 'Dialogs' },
      { name: 'DividersView', title: 'Dividers', i18n: 'Dividers' },
      {
        name: 'ExpansionPanels',
        title: 'Expansion Panels',
        i18n: 'ExpansionPanels',
      },
      { name: 'Footer', title: 'Footers', i18n: 'Footers' },
      {
        title: 'Form Control',
        group: 'forms-control',
        namespace: 'components',
        i18n: 'FormControl',
        items: [
          {
            name: 'Autocompletes',
            title: 'Autocompletes',
            exact: true,
            i18n: 'Autocompletes',
          },
          { name: 'Combobox', title: 'Combobox', i18n: 'Combobox' },
          { name: 'FileInputs', title: 'File Inputs', i18n: 'FileInputs' },
          { name: 'Forms', title: 'Forms', i18n: 'Forms' },
          { name: 'Inputs', title: 'Inputs', i18n: 'Inputs' },
          {
            name: 'OverflowBtns',
            title: 'Overflow Buttons',
            i18n: 'OverflowButtons',
          },
          { name: 'Selects', title: 'Selects', i18n: 'Selects' },
          {
            name: 'SelectionControls',
            title: 'Selection Controls',
            i18n: 'SelectionControls',
          },
          { name: 'Sliders', title: 'Sliders', i18n: 'Sliders' },
          { name: 'Textarea', title: 'Textareas', i18n: 'Textareas' },
          { name: 'Textfields', title: 'Textfields', i18n: 'Textfields' },
        ],
      },
      { name: 'Grids', title: 'Grids', i18n: 'Grids' },
      {
        title: 'Groups',
        group: 'groups',
        namespace: 'components',
        i18n: 'Groups',
        items: [
          { name: 'ItemGroups', title: 'Item Groups', i18n: 'ItemGroups' },
          { name: 'SlideGroups', title: 'Slide Groups', i18n: 'SlideGroups' },
          { name: 'Windows', title: 'Windows', i18n: 'Windows' },
        ],
      },
      { name: 'Hover', title: 'Hover', i18n: 'Hover' },
      { name: 'Icons', title: 'Icons', i18n: 'Icons' },
      { name: 'Images', title: 'Images', i18n: 'Images' },
      { name: 'Lazy', title: 'Lazy', i18n: 'Lazy' },
      {
        title: 'Lists',
        group: 'lists',
        namespace: 'components',
        i18n: 'Lists',
        items: [
          { name: 'Lists', title: 'List', exact: true, i18n: 'List' },
          { name: 'ItemGroupView', title: 'Item Group', i18n: 'ItemGroup' },
        ],
      },
      { name: 'Menus', title: 'Menus', i18n: 'Menus' },
      {
        name: 'NavigationDrawers',
        title: 'Navigation Drawers',
        i18n: 'NavigationDrawers',
      },
      { name: 'Overlays', title: 'Overlays', i18n: 'Overlays' },
      { name: 'Paginations', title: 'Paginations', i18n: 'Paginations' },
      { name: 'Parallax', title: 'Parallax', i18n: 'Parallax' },
      {
        title: 'Pickers',
        group: 'pickers',
        namespace: 'components',
        i18n: 'Pickers',
        items: [
          {
            name: 'ColorPickers',
            title: 'Color Pickers',
            i18n: 'ColorPickers',
          },
          { name: 'DatePickers', title: 'Date Pickers', i18n: 'DatePickers' },
          { name: 'TimePickers', title: 'TIme Pickers', i18n: 'TImePickers' },
        ],
      },
      {
        title: 'Progress',
        group: 'progress',
        namespace: 'components',
        i18n: 'Progress',
        items: [
          { name: 'CircularProgress', title: 'Circular', i18n: 'Circular' },
          { name: 'LinearProgress', title: 'Linear', i18n: 'Linear' },
        ],
      },
      { name: 'Ratings', title: 'Ratings', i18n: 'Ratings' },
      { name: 'Sheets', title: 'Sheets', i18n: 'Sheets' },
      {
        name: 'SkeletonLoaders',
        title: 'Skeleton Loaders',
        i18n: 'SkeletonLoaders',
      },
      { name: 'Snackbars', title: 'Snackbars', i18n: 'Snackbars' },
      { name: 'Steppers', title: 'Steppers', i18n: 'Steppers' },
      { name: 'Subheaders', title: 'Subheaders', i18n: 'Subheaders' },
      {
        title: 'Tables',
        group: 'tables',
        namespace: 'components',
        i18n: 'Tables',
        items: [
          {
            name: 'DataIterators',
            title: 'Data Iterators',
            i18n: 'DataIterators',
          },
          {
            name: 'SimpleTables',
            title: 'Simple Tables',
            i18n: 'SimpleTables',
          },
          { name: 'DataTables', title: 'Data Tables', i18n: 'DataTables' },
        ],
      },
      { name: 'Tabs', title: 'Tabs', i18n: 'Tabs' },
      { name: 'Timelines', title: 'Timelines', i18n: 'Timelines' },
      { name: 'Tooltips', title: 'Tooltips', i18n: 'Tooltips' },
      { name: 'Treeview', title: 'Treeview', i18n: 'Treeview' },
      {
        name: 'VirtualScrollers',
        title: 'VirtualScrollers',
        i18n: 'VirtualScrollers',
        badge: 'new',
      },
    ],
  },
  { header: 'Directives', i18n: 'Directives' },
  {
    title: 'Directives',
    group: 'directives',
    icon: 'mdi-function',
    i18n: 'Directives',
    items: [
      {
        name: 'ClickOutside',
        title: 'Click Outside',
        i18n: 'ClickOutside',
        badge: 'new',
      },
      { name: 'Intersect', title: 'Intersect', i18n: 'Intersect' },
      { name: 'Mutate', title: 'Mutate', i18n: 'Mutate' },
      { name: 'Resizing', title: 'Resizing', i18n: 'Resizing' },
      { name: 'Ripples', title: 'Ripples', i18n: 'Ripples' },
      { name: 'Scrolling', title: 'Scrolling', i18n: 'Scrolling' },
    ],
  },
  {
    header: 'Guide',
    i18n: 'Guide',
    hidden: true,
  },
  {
    icon: 'fas fa-file',
    title: 'Documentation',
    href: 'https://vuse-documention.hexesis.com/introduction',
    target: '_blank',
    i18n: 'Documentation',
    hidden: true,
  },
]
